import { CCardBody } from '@coreui/react-pro'
import React from 'react'

const ConfiaCarCardBody = (props) => {
  const { children } = props
  return <CCardBody {...props}>{children}</CCardBody>
}

export { ConfiaCarCardBody }
